'use strict';

var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');

function init(container, heading, activeClass, excludeState) {

	var $container = $(container);
	var $heading = $(heading);
	var activeClass = activeClass;
	var state = ViewportTracker.getState();

	if ($container.length === 0 || state === excludeState) {
		return;
	}

	$heading.on('click.openAccordion', function(event) {
		$container.addClass(activeClass);

		$heading.on('click.closeAccordion', function(event) {
			$container.removeClass(activeClass);
			$heading.off('click.closeAccordion');
		});
	});
}

module.exports = {
	init : init
};
